import React, { createContext, FC, useContext, useMemo, useReducer } from "react";

export interface State {
  displayDrawer: boolean;
  drawerView: string | null;
}

const initialState = {
  displayDrawer: false,
  drawerView: null,
};

type Action =
  | {
    type: "OPEN_DRAWER"
    view: string
    image: string | undefined
  }
  | {
    type: "CLOSE_DRAWER"
  }

export const DrawerContext = createContext<State | any>(initialState);
DrawerContext.displayName = "DrawerContext";

function drawerReducer(state: State, action: Action) {
  switch (action.type) {
  case "OPEN_DRAWER": {
    return {
      ...state,
      drawerView: action.view,
      displayDrawer: true,
    };
  }
  case "CLOSE_DRAWER": {
    return {
      ...state,
      drawerView: null,
      displayDrawer: false,
    };
  }
  }
}

export const DrawerProvider: FC = (props) => {
  const [state, dispatch] = useReducer(drawerReducer, initialState);
  const openDrawer = (view: string, image?: string) => dispatch({ type: "OPEN_DRAWER", view, image });
  const closeDrawer = () => dispatch({ type: "CLOSE_DRAWER" });

  const value = useMemo(
    () => ({
      ...state,
      openDrawer,
      closeDrawer,
    }),
    [state],
  );

  return <DrawerContext.Provider value={value} {...props} />;
};

export const useDrawer = () => {
  const context = useContext(DrawerContext);

  if (context === undefined) {
    throw new Error("useDrawer must be used within a UIProvider");
  }

  return context;
};
